export interface SingleFlight {
	tryStart(): boolean;
	finish(): void;
}

export const createSingleFlight = (): SingleFlight => {
	let inFlight = false;

	return {
		tryStart: () => {
			if (inFlight) {
				return false;
			}
			inFlight = true;
			return true;
		},
		finish: () => {
			inFlight = false;
		},
	};
};
